export interface ICariHesapEkstresi {
    cariID:number;
    tarih: Date;
    vade: Date;
    borc: number;
    alacak: number;
    bakiye: number;
    bakiyeDurumu: string;
    hareketTuru: string;
    aciklama: string;
}

export class CariHesapEkstresiFilter {
    baslangicTarihi: string;
    bitisTarihi: string;
    hesapID: number;
    hesapAdi: string;
    bakiye: number;
    durum: boolean;
    dataList: any;
}